module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/PrinceOfPersia_xbox_lrg.fc7e52c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/PrinceOfPersia_xbox_lrg.jpg
// module id = dZXk
// module chunks = 0